import React from "react";

function PatientInfoCard({ patient }) {
  const p = patient || {
    id: "68562d9d-0a5a-4c9d-b87e-351908ddd8d1",
    createdAt: "May 11, 2025 04:43 PM",
    modifiedAt: "Oct 24, 2025 11:24 PM",
    clinicId: "6dee498f-ef74-498c-96d1-587e00c87f72",
    userId: "75fa8ecb-13e9-4a02-857f-010d7f3e7b53",
    firstName: "Demo Patient",
    lastName: "Test",
    preferredName: "Demo Patient",
    dateOfBirth: "1972-12-24",
    gender: "MALE",
    phoneNumber: "(123) 456-7890",
    cellNumber: "(987) 654-3210",
    email: "augusta.demopatient@demo.com",
    street: "23835 Johnie Ranch",
    city: "North Alex",
    province: "Arkansas",
    postalCode: "38743-6396",
    country: "TZ",
    isActive: true,
    pmsId: "PMS-PTZUK7S",
  };

  const calculateAge = (dob) => {
    if (!dob) return "N/A";
    const birth = new Date(dob);
    const diff = new Date().getFullYear() - birth.getFullYear();
    const monthDiff = new Date().getMonth() - birth.getMonth();
    return monthDiff < 0 ? diff - 1 : diff;
  };

  const formatGender = (g) =>
    ({ MALE: "Male", FEMALE: "Female", OTHER: "Other" }[g] || g);

  return (
    <div className="card mt-4 shadow-sm border-0">
      <div className="card-body">
        <div className="d-flex justify-content-between flex-wrap">
          {/* Left Section */}
          <div className="d-flex align-items-start mb-3 mb-md-0">
            {/* Avatar */}
            <div className="avatar bg-primary text-white rounded-circle p-3 me-3 fs-4 fw-bold shadow-sm">
              {p.firstName?.charAt(0) || "?"}
              {p.lastName?.charAt(0) || ""}
            </div>

            {/* Patient Details */}
            <div>
              <h5 className="fw-bold mb-1">
                {p.firstName || "N/A"} {p.lastName || ""}
                {p.preferredName && (
                  <small className="text-muted ms-1">
                    ({p.preferredName})
                  </small>
                )}
              </h5>

              {p.pmsId && (
                <div className="text-muted mb-1">
                  <i className="bi bi-person-badge me-1"></i>
                  ID: {p.pmsId}
                </div>
              )}

              {p.dateOfBirth && (
                <div className="text-muted mb-1">
                  <i className="bi bi-cake me-1 text-secondary"></i>
                  {p.dateOfBirth}
                </div>
              )}

              {p.gender && (
                <div className="text-muted">
                  <i
                    className={`bi ${
                      p.gender.toLowerCase() === "male"
                        ? "bi-gender-male text-info"
                        : p.gender.toLowerCase() === "female"
                        ? "bi-gender-female text-danger"
                        : "bi-gender-ambiguous text-secondary"
                    } me-1`}
                  ></i>
                  {formatGender(p.gender)} ({calculateAge(p.dateOfBirth)})
                </div>
              )}
            </div>
          </div>
              <div>
                <div className="alert alert-success alert-sm">Status : Active</div>
              </div>
          {/* Right Section - Contact & Address */}
          <div className="d-flex flex-column text-end">
            {/* Address */}
            <div className="text-muted small">
              <div className="d-inline-block text-start">
                <div>{p.street || <small>N/A</small>}</div>
                <div>{p.city ? `${p.city}, ` : ""}</div>
                <div>
                  {p.province ? `${p.province}, ` : ""}
                  </div><div>
                  {p.postalCode || ""}
                </div>
                <div>{p.country || <small>N/A</small>}</div>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-between mt-2">
             {p.phoneNumber && (
                <div className="text-muted">
                  <i className="bi bi-telephone me-2 text-primary"></i>
                  {p.phoneNumber}
                </div>
              )}

               {p.cellNumber && (
                <div className="text-muted">
                  <i className="bi bi-phone me-2 text-success"></i>
                  {p.cellNumber}
                </div>
              )}

               {p.email && (
                <div className="text-muted">
                  <i className="bi bi-envelope me-2 text-info"></i>
                  {p.email}
                </div>
              )}
        </div>
        <div className="d-flex justify-content-evenly gap-2 mt-3">
      <button className="btn btn-sm btn-outline-primary d-flex align-items-center">
        <i className="bi bi-envelope me-2"></i>
        Send Email
      </button>
      <button className="btn btn-sm btn-outline-secondary d-flex align-items-center">
        <i className="bi bi-chat-dots me-2"></i>
        Send SMS
      </button>
      <button className="btn btn-sm btn-outline-info d-flex align-items-center">
        <i className="bi bi-clipboard-data me-2"></i>
        Send Survey
      </button>
      <button className="btn btn-sm btn-outline-warning d-flex align-items-center">
        <i className="bi bi-file-text me-2"></i>
        Send Articles
      </button>
      <button className="btn btn-sm btn-outline-primary d-flex align-items-center">
        <i className="bi bi-eyeglasses me-2"></i>
        Glass Pickup
      </button>
      <button className="btn btn-sm btn-outline-secondary d-flex align-items-center">
        <i className="bi bi-eye me-2"></i>
        Lens Pickup
      </button>
      <button className="btn btn-sm btn-outline-info d-flex align-items-center">
        <i className="bi bi-heart me-2"></i>
        Thank You
      </button>
      <button className="btn btn-sm btn-outline-warning d-flex align-items-center">
        <i className="bi bi-emoji-smile me-2"></i>
        Welcome
      </button>
    </div>
  
      </div>
    </div>
  );
}

export default PatientInfoCard;
